import { MUTED, PAGE_TITLE } from '@crowdex/ui/lib/desktop-styles';
import type { ReactNode } from 'react';

export function AuthPageContent({
  children,
  description,
  title,
}: {
  children: ReactNode;
  description: string;
  title: string;
}) {
  return (
    <>
      <header className="space-y-1">
        <h1 className={PAGE_TITLE}>{title}</h1>
        <p className={MUTED}>{description}</p>
      </header>
      {children}
    </>
  );
}
